// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import path from "./url.js";
import "element-ui/lib/theme-chalk/index.css";
import VueResource from "vue-resource";
import { postHttp, getHttp } from "@/utils/vueresource.js";
import "./assets/iconfont/iconfont.css";
import ElementUI from "element-ui";
import animated from "animate.css";
import gsap from "gsap";

import "@/assets/geoJson/initGeoJson.js";
// 将自动注册所有组件为全局组件
import "./views/videoAnalysis/js/video"
import scroll from "vue-seamless-scroll";
import dataV from "@jiaminghi/data-view";
import util from "@/utils/util.js";
import vuescroll from "vuescroll/dist/vuescroll-native";
import * as echarts from "echarts";
import "@/utils/componentRegister";
import common from "@/utils/common.js";
import publicObj from "@/utils/publicObj.js";
import "@/router/routingGuard"; // 路由守卫
import jsCookie from "js-cookie";
import { get, post } from "@/utils/apiAxios";
import store from "./store";
Vue.use(vuescroll);
Vue.use(scroll); // 无限滚动
Vue.use(VueResource);
Vue.use(ElementUI);
Vue.use(animated);
Vue.use(dataV);
Vue.use(gsap);

Vue.prototype.$publicObj = publicObj;
Vue.prototype.$jsCookie = jsCookie; // js-cookie库
Vue.prototype.$echarts = echarts;
Vue.prototype.$util = util;
Vue.prototype.$path = path;
Vue.prototype.$apiAxios = { get, post };
Vue.prototype.postHttp = postHttp;
Vue.prototype.getHttp = getHttp;
Vue.prototype.$common = common;
Vue.prototype.$width = "1920"; // 网页宽度
Vue.prototype.$height = "1080"; // 网页高度
Vue.prototype.$vw = function(px) {
    // 宽高换算
    return `${(px / 1920) * 100}vw`;
};
Vue.prototype.$vh = function(px) {
    return `${(px / 1080) * 100}vh`;
};
Vue.prototype.getHttp = getHttp;
Vue.prototype.$headCommon = Vue.http.headers;
Vue.config.productionTip = false;
/* eslint-disable no-new */
store.commit("userInfo/setUserInfo");
new Vue({
    el: "#app",
    router,
    store,
    components: { App },
    template: "<App/>"
});
// Vue.http.headers.post['Tenant-Id'] = '690547'
// Vue.http.headers.post['Authorization'] = 'Basic c3dvcmQ6c3dvcmRfc2VjcmV0'



// WEBPACK FOOTER //
// ./src/main.js